import { render, staticRenderFns } from "./Redeem.vue?vue&type=template&id=576c1c2c&scoped=true"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"
import style0 from "./Redeem.vue?vue&type=style&index=0&id=576c1c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c1c2c",
  null
  
)

export default component.exports